import { Link } from "react-router-dom";
import { Layers, ArrowRight } from "lucide-react";

export const NegativeSoles = ({ items }) => {
  if (!items?.length) return null;
  return (
    <section className="mb-8 rounded-lg border border-[#EF4444]/50 bg-[#FDECEC] p-5" data-testid="negative-soles-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Layers className="w-5 h-5 text-[#EF4444]" />
          <h2 className="font-display text-xl font-bold uppercase tracking-tight">Eksiye Düşen Tabanlar</h2>
        </div>
        <Link to="/taban" data-testid="negative-soles-link"
          className="text-sm font-medium text-[#B45309] hover:text-[#EF4444] flex items-center gap-1">
          Tabanlara git <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2">
        {items.map((s) => (
          <div key={s.key} data-testid={`negative-sole-${s.key}`}
            className="rounded-md border border-[#EF4444]/30 bg-[#FFFBF4] px-3 py-2">
            <p className="text-xs font-semibold truncate">{s.sole_code}</p>
            <p className="text-[10px] font-mono uppercase text-[#6B5B4A]">{s.sole_color || "—"} · N°{s.size}</p>
            <p className="font-mono text-lg font-bold text-[#EF4444]">{s.qty}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
